import { Component, OnInit, AfterViewInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { InstructorService } from "../report-services/instructor.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";

@Component({
	templateUrl: "./classroster.component.html",
})
export class ClassRosterComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private reportService: ReportService,
		private instructorService: InstructorService,
		private dialogService: DialogService
	) {}

	report = {
		SchoolID: 0,
		SemesterID: 0,
		InstructorID: 0,
		DayID: 0,
		PeriodID: 0,
		ImageLogo: "",
	};
	schoolList: any = [];
	semesterList: any = [];
	InstructorList: any = [];
	dayList: any = [];
	periodList: any = [];
	ImageLogoList: any = [];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 238;
	subscription: any;

	ngOnInit() {
		// this.loadSchoolist();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(238);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.SemesterList();
		this.loadInstructorList();
		this.DaysList();
		this.PeriodList();
		this.loadLogolist();
	}

	private SemesterList() {
		this.report.SemesterID = 0;
		var result = this.reportService.SemesterGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.semesterList = response;

				if (this.semesterList.length > 1) {
					this.semesterList.unshift({
						SemesterID: 0,
						Semester: "All Semesters",
					});
				} else {
					this.report.SemesterID = this.semesterList[0].SemesterID;
				}
			},
			(error) => {}
		);
	}

	private loadInstructorList() {
		this.report.InstructorID = 0;
		var result = this.instructorService.loadInstructorList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.InstructorList = response;

				if (this.InstructorList.length > 1) {
					this.InstructorList.unshift({
						Teacher_PersonID: 0,
						Instructor: "All Instructors",
					});
				} else {
					this.report.InstructorID = this.InstructorList[0].InstructorID;
				}
			},
			(error) => {}
		);
	}

	private DaysList() {
		this.report.DayID = 0;

		var result = this.reportService.DayGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.dayList = response;

				if (this.dayList.length > 1) {
					this.dayList.unshift({
						DayID: 0,
						DayDesc: "Daily",
					});
				} else if (this.dayList.length == 1) {
					this.report.DayID = this.dayList[0].DayID;
				} else {
					this.dayList.push({
						DayID: 0,
						DayDesc: "Daily",
					});
				}
			},
			(error) => {}
		);
	}

	private PeriodList() {
		this.report.PeriodID = 0;

		var result = this.reportService.PeriodGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.periodList = response;

				if (this.periodList.length > 1) {
					// this.periodList.unshift({
					//   PeriodID: 0,
					//   PeriodDesc: "All Periods"
					// })
				} else {
					this.report.PeriodID = this.periodList[0].PeriodID;
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		this.isProcessing = true;

		var strParam = this.GetStrParam();

		var reportID = 238;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);
		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		strParam += this.report.SchoolID + "|SchoolID";

		strParam += "," + this.report.SemesterID + "|SemesterID";
		strParam += "," + this.report.InstructorID + "|TeacherPersonID";
		strParam += "," + this.report.DayID + "|DayID";
		strParam += "," + this.report.PeriodID + "|PeriodID";

		// strParam += "," + vm.searchOptions.sortBy + "|ORDERBY"
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
